export default "__VITE_ASSET__CPclB4IM__"